module.exports = __webpack_public_path__ + "img/GAME_MULTI OMOK.b3933b6a.png";